/* global require */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Header } from 'native-base';
import { Col, Grid } from 'react-native-easy-grid';
import { Image, Dimensions, TouchableOpacity, Text } from 'react-native';
import { styles, C, PROJECT_TITLE } from '../../constants';
import { openURL } from '../../_helpers';

let deviceWidth = Dimensions.get('window').width;

import {
  sendLogout
} from '../../actions';

class AppHeader extends Component {

  handlerExit = () => {
    this.props.dispatch(sendLogout());
  }

  handlerPressLogo = () => {
    openURL("https://rzd-medicine.ru");
  }

  render() {
    return (
      <Header style={styles.appHeader}>
        <Grid>
          <Col style={styles.appHeaderCol_3}>
              <Text style={styles.appHeaderTitle}>
                  {PROJECT_TITLE}
              </Text>
          {/*    <Image*/}
          {/*  resizeMode='contain'*/}
          {/*  source={require('../../../assets/img/corona_logo.png')}*/}
          {/*  style={{*/}
          {/*    minWidth: 108,*/}
          {/*    height: 31,*/}
          {/*    width: "100%"*/}
          {/*  }}*/}
          {/*/>*/}
          </Col>
        </Grid></Header>
    );
  }
}


AppHeader.propTypes = {
  dispatch: PropTypes.func.isRequired
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps)(AppHeader);